import React from "react";
import {useMediaQuery} from "react-responsive";
const Article = () => {
    const isBigScreen = useMediaQuery({query: "(min-width: 750px)"});
    const isTabletOrMobile = useMediaQuery({query: "(max-width: 600px)"});
    return (
        <div className="mb-16">
            {isTabletOrMobile && <div className="wrapper grid background-article-mobile">
                <div className="col-start-6 col-span-6">
                    <h1 className="font-bold  m-3 text-1xl  tracking-widest font-sans">Dapatkan Penghasilan Puluhan Juta Rupiah Setiap Bulan Hanya dengan Modal 7 juta</h1><br/>
                    <p className="font-normal italic">Sukses Bersama Trawlbens</p>
                    <a href="https://trawlben.netlify.app/mitra-space/">
                        <button className="my-5  px-4 py-2 text-putih bg-[#CD3936] rounded-xl  ">
                            Daftar Sekarang !!!
                        </button>
                    </a>
                </div>
            </div>}

            {isBigScreen && <div className="wrapper grid md:grid-cols-12 background-article">
                <div className="col-start-6 col-span-6">
                    <h1 className="font-bold text-4xl leading-10 tracking-widest font-sans mt-20">Dapatkan Penghasilan Puluhan Juta Rupiah Setiap Bulan Hanya dengan Modal 7 juta</h1><br/>
                    <p className="font-normal italic text-xl leading-10 tracking-widest">Sukses Bersama Trawlbens</p>
                    <a href="https://trawlben.netlify.app/mitra-space/">
                        <button className="my-5  px-4 py-2 text-putih bg-[#CD3936] rounded-xl  ">
                            Daftar Sekarang !!!
                        </button>
                    </a>
                </div>
            </div>}
        </div>
    );
};

export default Article;
